import { ImageLinks } from './image-link'

export enum EPLATFORM {
  TIKTOK = 'tiktok',
  SHOPEE = 'shopee',
  LAZADA = 'lazada',
  LINE_MYSHOP = 'line_myshop',
}

export const platformMapImage = {
  "tiktok": ImageLinks.LOGO_CIRCLE_TIKTOK,
  "shopee": ImageLinks.LOGO_CIRCLE_SHOPEE,
  "lazada": ImageLinks.LOGO_CIRCLE_LAZADA,
  "line_myshop": ImageLinks.LOGO_CIRCLE_LINE_MY_SHOP,
}